import { createContext } from "react";

export const PageContext = createContext({
  button_override_title: "Search the CX insights hub",
  button_override_url: "/cx-insights-hub",
});
